"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _HorizontalTab = _interopRequireDefault(require("./HorizontalTab"));
var __jsx = _react.default.createElement;
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var HorizontalTabContainer = /*#__PURE__*/function (_Container) {
  (0, _inherits2.default)(HorizontalTabContainer, _Container);
  var _super = _createSuper(HorizontalTabContainer);
  function HorizontalTabContainer() {
    (0, _classCallCheck2.default)(this, HorizontalTabContainer);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(HorizontalTabContainer, [{
    key: "containerProps",
    get: function get() {
      var containerProps = (0, _get2.default)((0, _getPrototypeOf2.default)(HorizontalTabContainer.prototype), "containerProps", this);
      containerProps.className = (containerProps.className || '') + ' cmp-tabs';
      containerProps.role = 'group';
      containerProps['data-cmp-is'] = 'tabs';
      containerProps['data-cmp-full-width'] = this.props.fullWidth;
      return containerProps;
    }
  }, {
    key: "render",
    value: function render() {
      var findKey = function findKey(obj) {
        var mappedItems = Object.entries(obj).map(function (_ref) {
          var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            key = _ref2[0],
            item = _ref2[1];
          var isBuyAgain = (item === null || item === void 0 ? void 0 : item.typeId) === 'buyAgain';
          return {
            name: key,
            isBuyAgain: isBuyAgain
          };
        });
        return mappedItems;
      };
      var tabItems = findKey(this.props.cqItems);
      return __jsx("div", (0, _extends2.default)({}, this.containerProps, {
        id: this.props.anchorId,
        "aria-label": this.props.accessibilityLabel
      }), __jsx("div", {
        className: "cmp-horizontal-tab__content"
      }, __jsx(_HorizontalTab.default, {
        aemProps: this.props,
        containerProps: this.containerProps,
        tabItems: tabItems
      }, this.childComponents)), this.placeholderComponent);
    }
  }]);
  return HorizontalTabContainer;
}(_aemReactEditableComponents.Container);
var HorizontalTabEditConfig = {
  emptyLabel: 'Horizontal Tab Navigation',
  isEmpty: function isEmpty(props) {
    if (props.children && props.children.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/horizontaltab')(HorizontalTabContainer, HorizontalTabEditConfig);
exports.default = _default;